/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */

import store from '@/store/index'

export default [
  {
    path: '/login',
    view: 'Login',
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/',
    view: 'Dashboard',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/adspaces',
    view: 'Adspaces',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/api-keys',
    view: 'ApiKeys',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/multipliers',
    view: 'Multipliers',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/input',
    view: 'InputData',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/logout',
    redirect: to => {
      store.dispatch('logout')
    }
  }
]
